"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCellResize = void 0;
var _react = require("react");
var _TableUtils = require("./TableUtils");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/**
 * Calculates the column widths of the cells in rows.
 * @param {string} selector - the id or data-uuid of the row element or the element
 * @param {number} numColumns - number of columns to calculate width for
 * @param {number} usedSpace - total size in pixels of defined widths
 * @param {number} minColumnWidth - the min column width of each column
 * @param {boolean} subtractScrollbar - whether or not to subtract the scrollbar width when finding column width
 */
var useCellResize = function useCellResize(selector, numColumns, usedSpace) {
  var minColumnWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var subtractScrollbar = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    pixelWidth = _useState2[0],
    setPixelWidth = _useState2[1];
  var resize = (0, _react.useCallback)(function () {
    var el = document.getElementById(selector) || document.querySelector(selector);
    var _calculateColumnWidth = (0, _TableUtils.calculateColumnWidth)(el, numColumns, usedSpace, subtractScrollbar),
      _calculateColumnWidth2 = _slicedToArray(_calculateColumnWidth, 1),
      val = _calculateColumnWidth2[0];
    var width = Math.max(val, minColumnWidth);
    if (pixelWidth !== width) {
      setPixelWidth(width);
    }
  }, [selector, pixelWidth, numColumns, usedSpace, minColumnWidth, subtractScrollbar]); // effects
  // on resize re-calculate pixel width

  (0, _react.useEffect)(function () {
    window.addEventListener("resize", resize);
    return function () {
      window.removeEventListener("resize", resize);
    };
  }, [resize]);
  (0, _react.useLayoutEffect)(function () {
    if (!pixelWidth) {
      resize();
    }
  }, [pixelWidth, resize]);
  return pixelWidth;
};
exports.useCellResize = useCellResize;